module.exports = "<fw-menu>\r\n\r\n</fw-menu>\r\n<fw-submenu>\r\n\r\n</fw-submenu>";


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/home/home.component.html
// module id = 2312
// module chunks = 1